import axios from "axios";

const baseUrl = process.env.VUE_APP_API_URL + ""; // URL для получения данных
const config = { headers: { 'Cache-Control': 'no-cache' }, withCredentials: true };

export default {
    namespaced: true,
    state: {
        userAddresses: [], // адреса пользователя
    },
    mutations: {
        SET_USER_ADDRESSES(state, payload) {
            state.userAddresses = payload;
        },
    },
    actions: {
        async fetchUserAddresses({ commit }, params) {
            try {
                let transformedData;
                const response = await axios.get(
                    `${baseUrl}/addresses/getAddresses`,
                    {
                        params: params || {},
                        ...config
                    }
                );

                try {
                    const renameKeys = obj => {
                        return {
                            'ID': obj.delivery_address_id,
                            'Имя клиента': obj.user_fullname,
                            'Email': obj.user_email,
                            'Имя адреса': obj.address_name,
                            'Статус': obj.address_status,
                            'Служба доставки': obj.delivery_service,
                            'Индекс': obj.delivery_index,
                            'Страна': obj.country,
                            'Регион': obj.region,
                            'Город': obj.city,
                            'Улица': obj.street,
                            'Дом': obj.house,
                            'Квартира': obj.apartment,
                            'Яндекс ID': obj.ya_id
                        };
                    };

                    // Преобразование исходного массива
                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_USER_ADDRESSES', transformedData); // сохраняем данные в состояние
            } catch (error) {
                console.error(error);
            }
        },
    }
}